'use client'
import { useState } from 'react'
import { PrismicRichText } from '@prismicio/react'
import ChevronDown  from '@/assets/images/icons/icon-chevron-down.svg'


interface FAQDetailProps {
    faqData?: any | null
}

const FAQDetail:React.FC<FAQDetailProps>  = ({ faqData })=> {
    const [showFAQ, setShowFAQ] = useState(false);

    return (
      <div className="w-full text-[18px] leading-[24px] pb-4">
        <div className="grid grid-cols-12 gap-0 border-t-[1px] border-t-jade cursor-pointer hover:opacity-60" onClick={()=>setShowFAQ(!showFAQ)}>
          <div className="col-span-10 md:col-span-11 pt-4">
            {faqData.data.question}
          </div>
          <div className="col-span-2 md:col-span-1 py-4 flex justify-end">
            <ChevronDown className="stroke-jade w-[27px]"/>
          </div>
      </div>
      {showFAQ === true ? 
        <div className="mt-6 prose prose-p:m-0 prose-p:mb-4 prose-p:text-[18px] prose-p:leading-[24px] max-w-none pr-8">
            <PrismicRichText field={faqData.data.answer}/>
        </div>
      : null }
      </div>
    )
}


export default FAQDetail;

